import React, { Fragment, useEffect, useState } from "react";
import { LoadingOutlined, PlusCircleOutlined } from "@ant-design/icons";
import EditTimesheetSVG from "../../assets/icons/configedit.svg";
import { MdLocationOn } from "react-icons/md";
import { Card, Col, Row, DatePicker, Button, Empty, Grid, Tooltip } from "antd";
import { TimesheetConfirmationModal } from "./components/TimesheetConfirmationModal/TimesheetConfirmationModal.jsx";
import { TimesheetReasonModal } from "./components/TimesheetReasonModal/TimesheetReasonModal.jsx";
import "./ManageTimeSheet.css";
import { TimeSheetDownloadButton } from "./components/TimeSheetDownloadButton/TimeSheetDownloadButton";
import { TimeSheetTabPanes } from "./components/TimesheetTabPanes/TimeSheetTabPanes";
import {
  TIME_OF_REQUEST,
  TIME_SHEET,
  TIME_SHEET_APPROVED_ACTION,
  TIME_SHEET_REJECTED_ACTION,
} from "./TimeSheetConstants";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import {
  approveAllTimesheet,
  approveTimeOff,
  approveTimesheet,
  configTimeSheetInit,
  getConfigTimeSheetInit,
  getTimeOffListRequested,
  getTimeSheetList,
  rejectTimeOff,
  rejectTimeSheet,
  resetHeader,
} from "../../redux/actions";
import moment from "moment";
import { alertNotification } from "../../components/TopNotification/alertNotification.js";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min.js";
import history from "../../routes/history";
import { addQuery } from "../../shared/helpers.js";

const ManageTimesheet = () => {
  const {
    approveTimeSheetLoading,
    approveTimeOffLoading,
    approveAllTimeSheetLoading,
  } = useSelector((state) => state.TimesheetDetailsReducer);
  const shiftStartingDate = useSelector((state) => state.TimesheetListReducer.data);
  console.log(shiftStartingDate?.shiftStartDate,'timesheetDatas')
  const { loading: rejectTimesheetLoading, rejectTimeOffLoading } = useSelector(
    (state) => state.rejectTimeSheetReducer
  );
  const timesheetData = useSelector((state) => state.TimesheetListReducer.data);
  const loading = useSelector(
    (state) => state.TimesheetListReducer.isInitialLoading
  );
  const { configLoading } = useSelector(
    (state) => state.configTimeSheetReducer
  );
  const error = useSelector((state) => state.TimesheetListReducer.error);
  const timeSheetRows = useSelector(
    (state) => state.TimesheetListReducer.data?.data
  );
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();
  const { RangePicker } = DatePicker;
  const PageSize = 10;
  const TAB_LIST = [
    { label: "Timesheet", key: TIME_SHEET },
    {
      label: "Time Off Request",
      key: TIME_OF_REQUEST,
    },
  ];
  const [showTimesheetConfirmationModal, setShowTimesheetConfirmationModal] =
    useState(false);
  const [showTimeOffConfirmationModal, setShowTimeOffConfirmationModal] =
    useState(false);
  const [showApproveAllConfirmationModal, setShowApproveAllConfirmationModal] =
    useState(false);
  const [showTimeSheetReasonModal, setShowTimeSheetReasonModal] =
    useState(false);
  const [showTimeOffReasonModal, setShowTimeOffReasonModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const getTabFromQuery = (key) => {
    const params = new URLSearchParams(location.search);
    return params.get(key);
  };

  const [activeTab, setActiveTab] = useState(
    getTabFromQuery("tab") || TIME_SHEET
  );

  const [page, setPage] = useState(getTabFromQuery("page") || 1);
  const [dateRange, setDateRange] = useState([
    moment().startOf("month"),
    moment().endOf("month"),
  ]);

  const onTabChange = (key) => {
    setPage(1);
    setActiveTab(key);
    updateQueryParam("tab", key);
    getDataByTab({ tab: key });
  };

  const updateQueryParam = (key, value) => {
    const path = addQuery(key, value);
    history.push({
      search: path,
    });
  };

  const handleRangeChange = (dates) => {
    setDateRange(dates);
    getDataByTab({
      startDate: dates?.[0]?.format("YYYY-MM-DD"),
      endDate: dates?.[1]?.format("YYYY-MM-DD"),
    });
  };

  const getDataByTab = ({
    _page = page,
    startDate = dateRange?.[0]?.format("YYYY-MM-DD"),
    endDate = dateRange?.[1]?.format("YYYY-MM-DD"),
    tab = activeTab,
  }) => {
    if (tab == TIME_SHEET)
      handleGetTimesheet({ page: _page, startDate, endDate });
    else handleGetTimeOffList({ page: _page, startDate, endDate });
  };

  const TabActionButtons = ({ activeTab }) => {
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    let gutter = 4; // default for lg

    if (screens.sm) gutter = 1;
    if (screens.md) gutter = 2;
    if (screens.lg) gutter = 3;

    const isAllApproved = () => {
      try {
        return timeSheetRows.every(
          (el) =>
            el?.entry?.status == TIME_SHEET_APPROVED_ACTION ||
            el?.entry?.status == TIME_SHEET_REJECTED_ACTION
        );
      } catch (error) {
        return false;
      }
    };
    return (
      <Row justify="end" gutter={[gutter, 0]} wrap={false}>
        <Col className="range-picker-parent">
          <RangePicker
            size={"small"}
            value={dateRange}
            // format="YYYY-MM-DD"
            format={(value) => value.format("MMMM D, YYYY")}
            onChange={handleRangeChange}
          />
        </Col>
        {activeTab === TIME_SHEET ? (
          <Fragment>
            <Col>
              <TimeSheetDownloadButton dateRange={dateRange} timesheetId={id} />
            </Col>
            <Col>
              <Tooltip
                title={
                  isAllApproved() ? "All entries are already approved." : ""
                }
              >
                <Button
                  loading={approveAllTimeSheetLoading}
                  disabled={
                    approveAllTimeSheetLoading ||
                    !timesheetData?.data?.length ||
                    isAllApproved()
                  }
                  type="primary"
                  danger
                  className="time-sheet-approve-btn"
                  style={{
                    backgroundColor: "black !important",
                    color: "white",
                  }}
                  onClick={onClickApproveAll}
                >
                  Approve All
                </Button>
              </Tooltip>
            </Col>
          </Fragment>
        ) : (
          <Fragment></Fragment>
        )}
      </Row>
    );
  };

  const handleEditTimeSheetClick = (data) => {
    try {
      if (configLoading) return;
      dispatch(resetHeader());
      dispatch(
        getConfigTimeSheetInit({
          configureTimeSheetId: id,
          callBack: successCallBack,
        })
      );
    } catch (error) {}
  };

  const successCallBack = () => {
    history.push("/start-date");
  };

  const TimeSheetTopHeading = ({
    name = "",
    facilityName = "",
    location = "",
  }) => {
    return (
      <Row style={{ marignTop: "20px" }}>
        <Col span={24}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <h3 className="time-sheet-top-heading" style={{ margin: "0" }}>
              {name}'s Timesheet
            </h3>
            {shiftStartingDate?.shiftStartDate && moment(shiftStartingDate?.shiftStartDate).isAfter(moment(), "day") && (
  <Tooltip
    title="You can modify timesheet before start date."
    placement="right"
  >
    <span
      onClick={handleEditTimeSheetClick}
      style={{
        cursor: configLoading ? "not-allowed" : "pointer",
        marginLeft: "10px",
        width: "20px",
      }}
    >
      {configLoading ? (
        <LoadingOutlined />
      ) : (
        <img src={EditTimesheetSVG} alt="edit" />
      )}
    </span>
  </Tooltip>
)}
          </div>
        </Col>
        <Col span={24}>
          <p className="time-sheet-page-sub-heading">
            <PlusCircleOutlined />
            {facilityName}
          </p>
        </Col>
        <Col span={24}>
          <p className="time-sheet-page-sub-heading">
            <MdLocationOn style={{ marginRight: "5px" }} />
            {location}
          </p>
        </Col>
      </Row>
    );
  };

  const TabButton = ({ value, title, isSelected }) => {
    return (
      <Col
        className={`tab-btn ${isSelected ? "selected-tab" : ""}`}
        onClick={() => onTabChange(value)}
      >
        {title}
      </Col>
    );
  };

  const TabBar = () => {
    return (
      <Row className="tab-bar-top" justify="space-between" gutter={[0, 10]}>
        <Col className="tabs-col" xs={24} sm={24} md={8} lg={8} xl={7}>
          <Row
            wrap={false}
            gutter={[10, 0]}
            align="middle"
            style={{ height: "100%" }}
          >
            {TAB_LIST.map((el) => (
              <TabButton
                value={el.key}
                title={el.label}
                isSelected={activeTab == el.key}
              />
            ))}
          </Row>
        </Col>
        <Col style={{ margin: "5px 0px 6px 0px" }} md={16} lg={16}>
          <TabActionButtons activeTab={activeTab} />
        </Col>
      </Row>
    );
  };

  const handleGetTimesheet = (payload) => {
    dispatch(
      getTimeSheetList({
        timesheetId: id,
        ...payload,
      })
    );
  };

  const handleGetTimeOffList = (payload) => {
    dispatch(
      getTimeOffListRequested({
        timesheetId: id,
        ...payload,
      })
    );
  };

  const handleApproveRejectClick = (data) => {
    setSelectedId(data?._id);
    setShowTimesheetConfirmationModal(true);
  };

  const handleApproveRejectTimeOffClick = (data) => {
    setSelectedId(data?._id);
    setShowTimeOffConfirmationModal(true);
  };
  const handleShowReason = (data) => {
    setSelectedId(data?._id);
    setShowTimeOffConfirmationModal(true);
  };

  const handleTimesheetReasonSubmit = (reason) => {
    try {
      if (!reason) return alertNotification("error", "Enter reason");
      dispatch(
        rejectTimeSheet({
          timesheetId: selectedId,
          callBack: onSuccessfullyApprove,
          status: "rejected",
          rejectionReason: reason,
        })
      );
    } catch (error) {}
  };
  const handleTimeOffReasonSubmit = (reason) => {
    if (!reason) return alertNotification("error", "Enter reason");
    try {
      dispatch(
        rejectTimeOff({
          requestId: selectedId,
          callBack: onSuccessfullyApprove,
          status: "rejected",
          rejectionReason: reason,
        })
      );
    } catch (error) {}
  };

  const onClickApproveAll = () => {
    setShowApproveAllConfirmationModal(true);
  };

  const approveAll = () => {
    dispatch(
      approveAllTimesheet({
        callBack: onSuccessfullyApprove,
        timesheetId: id,
        startDate: dateRange?.[0]?.format("YYYY-MM-DD"),
        endDate: dateRange?.[1]?.format("YYYY-MM-DD"),
        page: page,
        pageSize: PageSize,
      })
    );
  };

  const callApproveTimesheet = (data) => {
    dispatch(
      approveTimesheet({
        timesheetId: selectedId,
        callBack: onSuccessfullyApprove,
        status: "approved",
      })
    );
  };
  const callApproveTimeOff = (data) => {
    dispatch(
      approveTimeOff({
        requestId: selectedId,
        callBack: onSuccessfullyApprove,
        status: "approved",
      })
    );
  };

  const onSuccessfullyApprove = () => {
    handlePageChange(page);
    setShowTimesheetConfirmationModal(false);
    setShowTimeOffConfirmationModal(false);
    setShowTimeOffConfirmationModal(false);
    setShowTimeOffReasonModal(false);
    setShowApproveAllConfirmationModal(false);
  };
  const handleRejectTimesheet = () => {
    setShowTimesheetConfirmationModal(false);
    setShowTimeSheetReasonModal(true);
  };
  const handleRejectTimeOff = () => {
    setShowTimeOffConfirmationModal(false);
    setShowTimeOffReasonModal(true);
  };

  const handlePageChange = (_page = page) => {
    updateQueryParam("page", _page);
    setPage(_page);
    getDataByTab({ _page });
  };

  useEffect(() => {
    getDataByTab({ tab: TIME_SHEET });
    getDataByTab({ tab: TIME_OF_REQUEST });
  }, []);

  if (loading) return <Card loading={true}></Card>;
  if (error) return <Empty style={{ marginTop: "20px" }} />;

  return (
    <Row className="time-sheet-page">
      <Col span={24} style={{ padding: "0px 10px" }}>
        <TimeSheetTopHeading
          name={timesheetData?.empInfo?.[0]?.fullName}
          facilityName={timesheetData?.empInfo?.[0]?.employerFacilityName}
          location={timesheetData?.empInfo?.[0]?.facilityLocation}
        />
        <TabBar />
        <TimeSheetTabPanes
          page={page}
          activeTab={activeTab}
          handleApproveRejectClick={handleApproveRejectClick}
          handleApproveRejectTimeOffClick={handleApproveRejectTimeOffClick}
          handleShowReason={handleShowReason}
          handlePageChange={handlePageChange}
        />
        <TimesheetConfirmationModal
          open={showTimesheetConfirmationModal}
          handleCancel={() => setShowTimesheetConfirmationModal(false)}
          handleApprove={callApproveTimesheet}
          handleReject={handleRejectTimesheet}
          loading={approveTimeSheetLoading}
        />
        <TimesheetConfirmationModal
          title="Approve/Reject Time Off Request"
          mainHeading="Are you sure you want to approve or reject the time off request?"
          open={showTimeOffConfirmationModal}
          handleCancel={() => setShowTimeOffConfirmationModal(false)}
          handleApprove={callApproveTimeOff}
          handleReject={handleRejectTimeOff}
          loading={approveTimeOffLoading}
        />
        <TimesheetConfirmationModal
          title="Approve All"
          mainHeading="Are you sure you want to approve all timesheet requests?"
          subHeading="*This action cannot be undone."
          open={showApproveAllConfirmationModal}
          handleCancel={() => setShowApproveAllConfirmationModal(false)}
          handleApprove={approveAll}
          handleReject={() => setShowApproveAllConfirmationModal(false)}
          loading={approveAllTimeSheetLoading}
          okButtonText={"Confirm"}
          cancelButtonText={"Cancel"}
        />

        <TimesheetReasonModal
          open={showTimeSheetReasonModal}
          handleSubmit={handleTimesheetReasonSubmit}
          loading={rejectTimesheetLoading}
          handleCancel={() => {
            setShowTimeSheetReasonModal(false);
            setShowTimesheetConfirmationModal(false);
          }}
        />

        <TimesheetReasonModal
          title="Reject Time Off Request"
          open={showTimeOffReasonModal}
          handleSubmit={handleTimeOffReasonSubmit}
          loading={rejectTimeOffLoading}
          handleCancel={() => {
            setShowTimeOffReasonModal(false);
            setShowTimeOffReasonModal(false);
          }}
        />
      </Col>
    </Row>
  );
};

export default ManageTimesheet;
